
import { MessageTemplate } from "../../classes"

const MessageTemplateModule = {
  namespaced: true,
  state: {
    messageTemplates: null
  },
  mutations: {
    setMessageTemplates(state, messageTemplates) {
      state.messageTemplates = messageTemplates
    },
  },
  actions: {
    getMessageTemplateByProject: async ({ commit }, projectId) => {
      try{
        commit("setMessageTemplates", null)
        const data = await MessageTemplate.getMessageTemplateByProject(projectId)
        commit("setMessageTemplates", data)
        return data
      }catch(error){
        throw error
      }
    },
    createMessageTemplate: async ({ commit }, formData) => {
      try{
        const data = await MessageTemplate.createMessageTemplate(formData)
        return data
      }catch(error){
        throw error
      }
    },
    updateMessageTemplate: async ({ commit }, formData) => {
      try{
        const data = await MessageTemplate.updateMessageTemplate(formData)
        return data
      }catch(error){
        throw error
      }
    },
    removeMessageTemplate: async ({ commit }, id) => {
      try{
        const data = await MessageTemplate.removeMessageTemplate(id)
        return data
      }catch(error){
        throw error
      }
    },
  },
  getters: {

  },
};
export default MessageTemplateModule;
